// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/sal?societaId={societaId}&commessaId={commessaId}',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","societaId":"number","sedeId":"number|null","commessaId":"number","ordineId":"number","numero":"string|null","stato":"BOZZA|EMESSO|APPROVATO_CLIENTE|APPROVATO_BACKOFFICE|FATTURATO","dataEmissione":"string|null","dataApprovazione":"string|null","tipoApprovazione":"string|null","importoTotale":"number","createdAt":"string","ordine":{"id":"number","numero":"string","flussoCommerciale":"string"},"commessa":{"id":"number","numero":"string","descrizione":"string|null","clienteRagioneSociale":"string|null"},"_count":{"righe":"number"}}]}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
